import { HeadGoverness } from 'vue-kindergarten';
import { redirectRoutes } from '@/kindergarten/perimeters';

export default class RouteGoverness extends HeadGoverness {
  constructor(perimeter) {
    super();
    this.perimeter = perimeter;
  }

  guard(action, { next, to }) {
    if (super.isNotAllowed(action)) {
      if (!localStorage.getItem('firstRedirect')) {
        localStorage.setItem('prevUrl', JSON.stringify(to));
        localStorage.setItem('firstRedirect', 1);
      }
      return next({
        name: redirectRoutes[this.perimeter],
      });
    }

    return next();
  }
}



// WEBPACK FOOTER //
// ./src/kindergarten/governesses/RouteGoverness.js